/**
 * @generated SignedSource<<6464f18fa14c0d01c89d931574590967>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type RateType = "CUSTOMER" | "GUEST" | "LESSON" | "MEMBER";
import { FragmentRefs } from "relay-runtime";
export type PublicTimeSlotCardWrapper_Timeslot$data = {
  readonly permittedCourseLayouts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly code: string;
        readonly default: boolean;
        readonly enabled: boolean;
        readonly holeCount: HoleCount;
        readonly id: string;
        readonly memberVisible: boolean;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly playerRateForMembershipType: {
    readonly eighteenHolePrice: number | null | undefined;
    readonly nineHolePrice: number | null | undefined;
    readonly rate: {
      readonly code: string;
      readonly id: string;
      readonly name: string;
      readonly type: RateType;
    };
  } | null | undefined;
  readonly rates: ReadonlyArray<{
    readonly eighteenHolePrice: number | null | undefined;
    readonly nineHolePrice: number | null | undefined;
    readonly rate: {
      readonly code: string;
      readonly id: string;
      readonly name: string;
      readonly type: RateType;
    };
  } | null | undefined> | null | undefined;
  readonly transportationTypes: ReadonlyArray<{
    readonly eighteenHolePrice: number | null | undefined;
    readonly id: string;
    readonly nineHolePrice: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"InlineRestrictionsList_timeSlot">;
  readonly " $fragmentType": "PublicTimeSlotCardWrapper_Timeslot";
};
export type PublicTimeSlotCardWrapper_Timeslot$key = {
  readonly " $data"?: PublicTimeSlotCardWrapper_Timeslot$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublicTimeSlotCardWrapper_Timeslot">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "memberVisible",
  "value": true
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v5 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v6 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "rate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": "nineHolePrice",
    "args": (v5/*: any*/),
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
  },
  {
    "alias": "eighteenHolePrice",
    "args": (v6/*: any*/),
    "kind": "ScalarField",
    "name": "totalGolfPrice",
    "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublicTimeSlotCardWrapper_Timeslot",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineRestrictionsList_timeSlot"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        },
        (v0/*: any*/)
      ],
      "concreteType": "CourseLayoutConnection",
      "kind": "LinkedField",
      "name": "permittedCourseLayouts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseLayoutEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseLayout",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "memberVisible",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "default",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "holeCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "permittedCourseLayouts(first:10,memberVisible:true)"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "membershipTypeId",
          "variableName": "membershipTypeId"
        },
        (v4/*: any*/)
      ],
      "concreteType": "SlotRate",
      "kind": "LinkedField",
      "name": "playerRateForMembershipType",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "transportationTypes",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": "nineHolePrice",
          "args": (v5/*: any*/),
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"NINE\")"
        },
        {
          "alias": "eighteenHolePrice",
          "args": (v6/*: any*/),
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
        }
      ],
      "storageKey": "transportationTypes(memberVisible:true)"
    },
    {
      "alias": "rates",
      "args": [
        {
          "kind": "Literal",
          "name": "highestPrecedentOnly",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "nonPlayingHost",
          "value": false
        },
        (v4/*: any*/)
      ],
      "concreteType": "SlotRate",
      "kind": "LinkedField",
      "name": "playerRates",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": "playerRates(highestPrecedentOnly:true,nonPlayingHost:false,type:\"CUSTOMER\")"
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};
})();

(node as any).hash = "ddc401850ae182b943e66e7ce418d7f5";

export default node;
